import { render } from "./ToggleMenu.vue?vue&type=template&id=8aaa7e62&ts=true"
import script from "./ToggleMenu.vue?vue&type=script&lang=ts"
export * from "./ToggleMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__